import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ManagementApiService } from 'src/app/services';
import { environment } from 'src/environments/environment.prod';
import { EmailConstants } from '../constants/email.contatnt';
import { ContactUsForm } from '../models/contact-us.model';
import { EmailModel } from '../models/email.model';
import { EmailNewOrgAdd } from '../models/Emails.model';
import { EmailType } from '../models/enums/email-type.enum';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root',
})
export class EmailSenderService {
    emailData: EmailNewOrgAdd;
    contactUsData: ContactUsForm;
    constructor(
        private managementApiService: ManagementApiService,
        private translocoService: TranslocoService,
        private EnvironmentService: EnvironmentService
    ) {}

    // * helper method to sent an email based on transaction
    emailHandler(emailType: number, toAddress?: string[], requiredDataForEmail?: any) {
        let emailPayload = new EmailModel();
        emailPayload.toAddresses = toAddress;
        emailPayload.ccAddresses = [];

        // * generting cc address list
        if (this.EnvironmentService.getConfig().testEmailIds) {
            let ccList = this.EnvironmentService.getConfig().testEmailIds.split(',');

            // * validation is added because if someone enters unformated email then api will throw error , so due to validation only valid email shold pass in cc list
            ccList.forEach((email) => {
                if (/(.+)@(.+){2,}\.(.+){2,}/.test(email)) {
                    emailPayload.ccAddresses.push(email);
                }
            });
        }

        switch (emailType) {
            // * send mail for contact us page
            case EmailType.ContactUsPage:
                return this.managementApiService.sentEmail(requiredDataForEmail);

            // * when new org is created
            case EmailType.NewOrgAdded:
                emailPayload.subject = this.translocoService.translate('EMAIL_TEMPLATES.NEW_ORG_ADD_EMAIL.SUBJECT');
                this.emailData = new EmailNewOrgAdd();
                this.emailData = requiredDataForEmail;
                emailPayload.body = this.translocoService.translate('EMAIL_TEMPLATES.NEW_ORG_ADD_EMAIL.BODY', {
                    firstName: this.emailData.firstName ? this.emailData.firstName : this.emailData.lastName ? this.emailData.lastName : this.emailData.email,
                    organizationName: this.emailData.organizationName,
                    integrityAssuredImg: EmailConstants.EMAIL_LOGOS.INTEGRITY_ASSURED,
                    hydratightImg: EmailConstants.EMAIL_LOGOS.HYDRATIGHT,
                });
                return this.managementApiService.sendEmailThroughOutWebApp(emailPayload);

            // * when new instance is created
            case EmailType.NewInstance:
                // file deepcode ignore OverwriteAssignment: <please specify a reason of ignoring this>
                this.emailData = new EmailNewOrgAdd();
                this.emailData = requiredDataForEmail;
                emailPayload.subject = this.translocoService.translate('EMAIL_TEMPLATES.INSTANCE_ADD_EMAIL.SUBJECT');
                emailPayload.body = this.translocoService.translate('EMAIL_TEMPLATES.INSTANCE_ADD_EMAIL.BODY', {
                    firstName: this.emailData.firstName ? this.emailData.firstName : this.emailData.lastName ? this.emailData.lastName : this.emailData.email,
                    organizationName: this.emailData.organizationName,
                    instanceName: this.emailData.instanceName,
                    navigateLink: EmailConstants.WEBSITE_ACCESS_LINK,
                    integrityAssuredImg: EmailConstants.EMAIL_LOGOS.INTEGRITY_ASSURED,
                    hydratightImg: EmailConstants.EMAIL_LOGOS.HYDRATIGHT,
                });
                return this.managementApiService.sendEmailThroughOutWebApp(emailPayload);

            // * when user is added in org
            case EmailType.NewUserAddedOrg:
                // emailPayload.toAddresses.push("parth.shah@enerpac.com"); // ! this will be removed once it passes, it is for @Sivakumar while testing he will able to get the email which user has received.
                emailPayload.subject = this.translocoService.translate('EMAIL_TEMPLATES.USER_ADDED_IN_ORG_EMAIL.SUBJECT');
                this.emailData = new EmailNewOrgAdd();
                this.emailData = requiredDataForEmail;
                emailPayload.body = this.translocoService.translate('EMAIL_TEMPLATES.USER_ADDED_IN_ORG_EMAIL.BODY', {
                    firstName: this.emailData.firstName ? this.emailData.firstName : this.emailData.lastName ? this.emailData.lastName : this.emailData.email,
                    organizationName: this.emailData.organizationName,
                    integrityAssuredImg: EmailConstants.EMAIL_LOGOS.INTEGRITY_ASSURED,
                    hydratightImg: EmailConstants.EMAIL_LOGOS.HYDRATIGHT,
                    navigateLink: EmailConstants.WEBSITE_ACCESS_LINK,
                });
                return this.managementApiService.sendEmailThroughOutWebApp(emailPayload);

            // * when user is in added in instance
            case EmailType.NewUserAddedIns:
                // emailPayload.toAddresses.push("sivakumar.ilango@enerpac.com"); // ! this will be removed once it passes, it is for @Sivakumar while testing he will able to get the email which user has received.
                this.emailData = new EmailNewOrgAdd();
                this.emailData = requiredDataForEmail;
                emailPayload.subject = this.translocoService.translate('EMAIL_TEMPLATES.USER_ADDED_IN_INSTANCE_EMAIL.SUBJECT');

                this.emailData = requiredDataForEmail;
                emailPayload.body = this.translocoService.translate('EMAIL_TEMPLATES.USER_ADDED_IN_INSTANCE_EMAIL.BODY', {
                    firstName: this.emailData.firstName ? this.emailData.firstName : this.emailData.lastName ? this.emailData.lastName : this.emailData.email,
                    organizationName: this.emailData.organizationName,
                    instanceName: this.emailData.instanceName,
                    navigateLink: EmailConstants.WEBSITE_ACCESS_LINK,
                    integrityAssuredImg: EmailConstants.EMAIL_LOGOS.INTEGRITY_ASSURED,
                    hydratightImg: EmailConstants.EMAIL_LOGOS.HYDRATIGHT,
                });
                return this.managementApiService.sendEmailThroughOutWebApp(emailPayload);

            // * when user is added into non-federated org
            case EmailType.NewUserAddNonFedOrg:
                emailPayload.subject = this.translocoService.translate('EMAIL_TEMPLATES.USER_ADDED_IN_NON_FED_ORG.SUBJECT');
                this.emailData = new EmailNewOrgAdd();
                this.emailData = requiredDataForEmail;
                emailPayload.body = this.translocoService.translate('EMAIL_TEMPLATES.USER_ADDED_IN_NON_FED_ORG.BODY', {
                    firstName: this.emailData.firstName ? this.emailData.firstName : this.emailData.lastName ? this.emailData.lastName : this.emailData.email,
                    organizationName: this.emailData.organizationName,
                    integrityAssuredImg: EmailConstants.EMAIL_LOGOS.INTEGRITY_ASSURED,
                    hydratightImg: EmailConstants.EMAIL_LOGOS.HYDRATIGHT,
                    navigateLink: EmailConstants.WEBSITE_ACCESS_LINK,
                    password: this.emailData.password,
                });
                return this.managementApiService.sendEmailThroughOutWebApp(emailPayload);

            // * when demo user sign up's
            case EmailType.DemoUserSignUp:
                // emailPayload.ccAddresses.push('krimaben.desai@enerpac.com');
                emailPayload.subject = this.translocoService.translate('EMAIL_TEMPLATES.DEMO_USER_SIGN_UP.SUBJECT');
                this.emailData = new EmailNewOrgAdd();
                this.emailData = requiredDataForEmail;
                emailPayload.body = this.translocoService.translate('EMAIL_TEMPLATES.DEMO_USER_SIGN_UP.BODY', {
                    firstName: this.emailData.firstName ? this.emailData.firstName : this.emailData.lastName ? this.emailData.lastName : this.emailData.email,
                    userEmail: this.emailData.email,
                    navigateLink: EmailConstants.WEBSITE_ACCESS_LINK,
                    contactUsLink: EmailConstants.CONTACT_US_LINK,
                    integrityAssuredImg: EmailConstants.EMAIL_LOGOS.INTEGRITY_ASSURED,
                    hydratightImg: EmailConstants.EMAIL_LOGOS.HYDRATIGHT,
                });
                return this.managementApiService.sendEmailThroughOutWebApp(emailPayload);
        }
    }
}
